import ZebraBrowserPrintWrapper from "zebra-browser-print-wrapper";

export const printBarcode = async (serial) => {
  console.log({ serial }, "serial");
  const browserPrint = new ZebraBrowserPrintWrapper();
  const defaultPrinter = await browserPrint.getDefaultPrinter();
  browserPrint.setPrinter(defaultPrinter);

  const printerStatus = await browserPrint.checkPrinterStatus();

  if (printerStatus.isReadyToPrint) {
    // const serial = "123456789"; // Replace this with your 9-digit serial number
    // const zpl = `^XA
    //                         ^BY1.5,1.5,100
    //                         ^FO20,20^BC^FD${serial}^FS
    //                         ^XZ`;

    console.log("newZpl");
    const newZpl = `CT~~CD,~CC^~CT~
      ^XA
      ~TA000
      ~JSN
      ^LT0
      ^MNW
      ^MTT
      ^PON
      ^PMN
      ^LH0,0
      ^JMA
      ^PR4,4
      ~SD15
      ^JUS
      ^LRN
      ^CI27
      ^PA0,1,1,0
      ^XZ
      ^XA
      ^MMT
      ^PW639
      ^LL200
      ^LS0
      ^BY2,3,93^FT26,137^BCN,,Y,N
      ^FH\^FD>;${serial}^FS
      ^PQ1,0,1,Y
      ^XZ
      `;
    browserPrint.print(newZpl);

    return { success: true };
  } else {
    console.error("Printer is not ready to print:", printerStatus);
    return {
      success: false,
      message:
        "Printer is not ready to print. Please check the printer and try again.",
    };
  }
};
